import React from 'react'

export const RoundedMinus: React.FC<React.SVGProps<SVGSVGElement>> = ({ width = '32', height = '32', ...restProps }) => {
    const strokeColor = restProps.stroke || '#3366CC'
    const fillColor = restProps.fill || 'white' 
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...restProps}
        >
            
            <rect fill={fillColor} height="31" rx="15.5" stroke={strokeColor} width="31" x="0.5" y="0.5" />
            <path d="M9 16H23" stroke={strokeColor} strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}
